import { useState } from 'react'

import { ChildProps } from '@/common/util/props'

import IconButton from '@/components/view/atoms/button/IconButton'
import { IconType } from '@/components/view/atoms/icon/Icon'
import Text from '@/components/view/atoms/text/Text'
import InsideArea, { BgColor } from '@/components/view/layouts/area/InsideArea'
import {
  DisclosurePositionHorizon,
  DisclosurePositionVertical,
  DisclosureSize
} from '@/components/view/layouts/disclosure/Disclosure'
import DisclosureWrapper from '@/components/view/layouts/disclosure/DisclosureWrapper'

interface Props extends ChildProps {
  horizon?: DisclosurePositionHorizon
  vertical?: DisclosurePositionVertical
}
const DescriptionDisclosure = ({ children, horizon, vertical }: Props) => {
  const [showing, setShowing] = useState<boolean>(false)
  return (
    <DisclosureWrapper
      size={DisclosureSize.MEDIUM}
      horizon={horizon}
      vertical={vertical}
      disclosureNode={
        <InsideArea color={BgColor.SECONDARY}>
          <Text size={12} fullWidth tag='p'>
            {children}
          </Text>
        </InsideArea>
      }
      off={!showing}
      onClickOutSide={() => setShowing(false)}
    >
      <IconButton type={IconType.HELP} size={24} line onClick={() => setShowing(!showing)} />
    </DisclosureWrapper>
  )
}

export default DescriptionDisclosure
